/**
 *  Tabs script file
**/

export default {
  name: 'Tabs',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      tabs: []
    }
  },
  computed: {
  },
  created () {
    this.tabs = this.$children
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.selected || (tab.id === selectedTab.id || tab.id === selectedTab)
      })

      this.$emit('toggle', selectedTab)
    }
  }
}
